import { useEffect, useState, useRef, useCallback } from "react";
import { SignIn, useAuth, useUser, useClerk, useSession } from "@clerk/react";
import { setGetClerkToken, dBConn, AM_version, getUserDataFn, setSignOut } from "./ApiCenter/API_GET";
import { GetHelp } from './Components/GetHelp';
import SetUpMfa from "./Components/SetUpMfa";
import {LoginBackToKRAST} from './ApiCenter/ELECTRON/support/AM_UIElements'

const ClerkApiInitializer = () => {
    
    const redirectUrl = `${window.location.pathname}${window.location.search}`;

    const getTokenRef = useRef(null);
    const { getToken } = useAuth();
    const { isSignedIn, isLoaded } = useUser();
    const { signOut } = useClerk();
    const { session } = useSession();
    const [userData, setUserData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [mfa, setMfa] = useState(false);

    const validateSession = useCallback(() => {
        const params = new URLSearchParams(window.location.search);
        const redirectUri = params.get('redirect_uri');
 
        if(redirectUri && window.location.pathname === '/login') {
            getTokenRef.current?.().then(t => {
                window.location.href = `${redirectUri}?token=${encodeURIComponent(t)}`;
            });
            return;
        }
        
        const credentials = { versionapp: AM_version(), domain: window.location.hostname };
        dBConn.post('validateSession', credentials).then(response => {
            if(response?.setMfa) {
                setMfa(true);
            } else if(response?.access){
                setMfa(false);
                setUserData(response.data.userData);
            } else if(response?.access === false){
                setMfa(false);
                setUserData('deactivated');
            } else {
                setMfa(false);
                setUserData('error');
            }
        }).finally(() => setIsLoading(false))
    }, [])

    useEffect(() => {
        if(!isLoading) return;
        validateSession();
    }, [isLoading, validateSession])
    
    useEffect(() => {
        if(session?.status !== 'active') return;
        if (isSignedIn) {
            setIsLoading(true);
        } else if(isLoaded) {
            setUserData(null);
        }
    }, [isLoaded, isSignedIn, session?.status]);

    useEffect(() => {
        if(!isSignedIn) setUserData(null);
    }, [isSignedIn]);

    useEffect(() => {
        getTokenRef.current = async() => await getToken?.({template: 'AudioMate', skipCache: true});
        setGetClerkToken(getTokenRef.current);
    }, [getToken]);

    useEffect(() => {
        setSignOut(signOut);
    }, [signOut]);

    useEffect(() => {
        const setUserDataFn = getUserDataFn();
        setUserDataFn?.(userData);
    }, [userData])

    if(mfa) return (
        <>  
            <div className="container" >
                <div className="row justify-content-center">
                    <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
                        <div className="d-flex justify-content-center py-4" style={{position: 'relative'}}>
                            <a href={window.location.href} className="logo d-flex align-items-center w-auto">
                                <img src="/assets/img/kantan-audiomate_logo-color.png" alt="" />
                                 {/*<span className="d-none d-lg-block">AudioMate</span>*/}
                            </a>
                            <a 
                                href="/" 
                                data-bs-toggle="dropdown" 
                                data-bs-auto-close="outside" 
                                title="Need help?"
                                style={{fontSize: '28px', color: '#1a3763', position: 'absolute', right: '-48px'}}
                            >
                                <i className=" bi bi-question-circle"/>
                            </a>
                            <ul 
                                className="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications audiomate-notifications" 
                                style={{paddingBottom: '0'}}
                            >
                                <li><GetHelp fromLoggin={true}/></li>      
                            </ul>
                        </div>
                        <div className="card mb-3">
                            <SetUpMfa onComplete={validateSession}/>    
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

    if((isSignedIn && userData && session?.status === 'active') || ['error', 'deactivated'].includes(userData)) return null;

    if(!isLoaded || isLoading) return <div style={{width: '100%', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>Loading...</div>;

    if(!isSignedIn || session?.status !== 'active') {

        return  (
            <>    
                <div className="container">
                    <LoginBackToKRAST />
                    <div className="row justify-content-center">
                        <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
                            <div className="d-flex justify-content-center py-4" style={{position: 'relative'}}>
                                <a href={window.location.href} className="logo d-flex align-items-center w-auto">
                                    <img src="/assets/img/kantan-audiomate_logo-color.png" alt="" />
                                     {/*<span className="d-none d-lg-block">AudioMate</span>*/}
                                </a>
                                <a 
                                    href="/" 
                                    data-bs-toggle="dropdown" 
                                    data-bs-auto-close="outside" 
                                    title="Need help?"
                                    style={{fontSize: '28px', color: '#1a3763', position: 'absolute', right: '-48px'}}
                                >
                                    <i className=" bi bi-question-circle"/>
                                </a>
                                <ul 
                                    className="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications audiomate-notifications" 
                                    style={{paddingBottom: '0'}}
                                >
                                    <li><GetHelp fromLoggin={true}/></li>      
                                </ul>
                            </div>
                            <div className="card mb-3">
                                <SignIn fallbackRedirectUrl={redirectUrl} />    
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default ClerkApiInitializer;